let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cxWGL")).then(() => parcelRequire('2TG3u'));